/**
 * Component Entry
 *
 */

import Logo from './Logo'
export default Logo
export * from './Logo'
